export default __webpack_public_path__ + "static/media/GuyAnimation9.83884f8c.svg";